<template>
  <PopupModal @close="$emit('close')">
    <template #heading>
      <span v-text="heading" />
    </template>
    <template #body>
      <img v-if="imageUrl" :src="imageUrl" class="general-popup-image" />
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="general-popup-body" v-html="bodyHtml"></div>
      <a :href="buttonUrl" class="general-popup-button" :target="buttonTarget" @click="onClick">{{ buttonLabel }}</a>
      <iframe v-if="conversionUrl" :src="conversionUrl" class="conversion-iframe" />
    </template>
  </PopupModal>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api';
import { markdownRenderer } from 'lib/markdown';
import PopupModal from 'components/popup/PopupModal.vue';

export default defineComponent({
  name: 'GeneralPopup',
  components: {
    PopupModal,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    bodyMarkdown: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: undefined,
    },
    buttonUrl: {
      type: String,
      default: undefined,
    },
    conversionUrl: {
      type: String,
      default: undefined,
    },
  },
  emits: {
    close: () => true,
  },
  setup(props, { emit }) {
    const onClick = (e: any) => {
      if (props.buttonUrl === '' || props.buttonUrl == null) {
        e.preventDefault();
        emit('close');
      }
    };
    const buttonLabel = props.buttonUrl ? '詳しくはこちら' : '閉じる';
    const buttonTarget = props.buttonUrl ? '_blank' : '_self';
    const md = markdownRenderer();
    const bodyHtml = computed(() => md.render(props.bodyMarkdown));

    return {
      onClick,
      buttonLabel,
      buttonTarget,
      bodyHtml,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';

.general-popup-body {
  font-weight: 300;
  font-size: 14px;
  line-height: 1.57;
  color: $v2-main-color;
  background: $v2-text-white;
  padding: 12px;

  &::v-deep p {
    margin-bottom: 17px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &::v-deep a {
    color: $v2-link-color;
  }
}

.general-popup-button {
  background: $v2-link-color;
  border-radius: 2px;
  color: #ffffff;
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 40px;
  margin: 40px 0 0;
  text-align: center;
  cursor: pointer;
}

.general-popup-image {
  margin-bottom: 24px;
  width: 100%;
}

.conversion-iframe {
  display: none;
  visibility: hidden;
  width: 1px;
  height: 1px;
  position: fixed;
  bottom: -1px;
  right: -1px;
}
</style>
